/**
 * ExportButton — Dropdown PDF/Excel, lädt Datei vom Backend.
 */
import { useState, useRef, useEffect } from 'react';

const API = import.meta.env.VITE_API_URL || '';

export default function ExportButton({ bereich, periodQuery }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const ref = useRef(null);

  useEffect(() => {
    function handler(e) { if (ref.current && !ref.current.contains(e.target)) setOpen(false); }
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  async function download(format) {
    setBusy(true);
    setOpen(false);
    try {
      const url = `${API}/api/investor/export/${bereich}.${format}?${periodQuery}`;
      const res = await fetch(url, { credentials: 'include' });
      if (!res.ok) throw new Error(`Export fehlgeschlagen (${res.status})`);
      const blob = await res.blob();
      const a = document.createElement('a');
      const objectUrl = URL.createObjectURL(blob);
      a.href = objectUrl;
      const cd = res.headers.get('content-disposition') || '';
      const match = cd.match(/filename="([^"]+)"/);
      a.download = match ? match[1] : `weship-investor-${bereich}.${format}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      URL.revokeObjectURL(objectUrl);
    } catch (e) {
      alert('Export-Fehler: ' + e.message);
    } finally {
      setBusy(false);
    }
  }

  return (
    <div ref={ref} className="relative">
      <button
        onClick={() => setOpen(!open)}
        disabled={busy}
        className="text-xs px-3 py-1.5 rounded-md border border-[#E5E7EB] bg-white hover:bg-[#F8F9FC] flex items-center gap-1 disabled:opacity-60"
      >
        {busy ? 'Lade…' : 'Export'}
        <svg width="10" height="10" viewBox="0 0 10 10"><path d="M2 4l3 3 3-3" stroke="currentColor" fill="none" strokeWidth="1.5" /></svg>
      </button>
      {open && (
        <div className="absolute right-0 top-full mt-1 bg-white border border-[#E5E7EB] rounded-md shadow-sm py-1 z-10 w-32">
          <button onClick={() => download('xlsx')} className="w-full px-3 py-1.5 text-xs text-left hover:bg-[#F8F9FC]">Excel (.xlsx)</button>
          <button onClick={() => download('pdf')} className="w-full px-3 py-1.5 text-xs text-left hover:bg-[#F8F9FC]">PDF (.pdf)</button>
        </div>
      )}
    </div>
  );
}
